var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-select',{staticClass:"no-margin-select mt-3",attrs:{"outline":"","search":"","label":"Client","visible-options":20,"disabled":_vm.disabled},on:{"getValue":function($event){return _vm.clientSelected($event)}},model:{value:(_vm.clientsModel),callback:function ($$v) {_vm.clientsModel=$$v},expression:"clientsModel"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1332667e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalcControlsClientSelect.vue
// module id = null
// module chunks = 